import React, { useEffect } from "react";
import {
  Paper,
  Grid,
  Autocomplete,
  TextField,
  CircularProgress,
  Button,
  Box,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const InvoiceTemplateFilter = React.memo(
  ({
    customerIsAdmin,
    fetchCustomers,
    allCustomers,
    selectedCustomerId,
    setSelectedCustomerId,
    autocompleteInputValue,
    setAutocompleteInputValue,
    loadingCustomers,
    searchKeyword,
    setSearchKeyword,
    onSearch,
  }) => {
    /*Delay khung nhập tên khách hàng*/
    useEffect(() => {
      const timer = setTimeout(() => {
        fetchCustomers(autocompleteInputValue);
      }, 500);
      return () => {
        clearTimeout(timer);
      };
    }, [autocompleteInputValue, fetchCustomers]);
    let customer = allCustomers.map((cus) => ({
      id: cus.CusId,
      name: cus.CusCompanyName,
    }));
    return (
      <Paper elevation={3} sx={{ p: 2, mb: 3 }}>
        <Grid container spacing={2} alignItems="flex-end">
          {customerIsAdmin && (
            <Grid size={{ xs: 12, sm: 4, md: 3 }}>
              <Autocomplete
                fullWidth
                size="small"
                options={allCustomers}
                getOptionLabel={(option) => option.name || ""}
                value={
                  customer.find((cus) => cus.id === selectedCustomerId) || null
                }
                onChange={(event, newValue) =>
                  setSelectedCustomerId(newValue?.id)
                }
                filterOptions={(x) => x}
                onInputChange={(event, newInputValue) =>
                  setAutocompleteInputValue(newInputValue)
                }
                loading={loadingCustomers}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Chọn khách hàng"
                    variant="outlined"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loadingCustomers ? (
                            <CircularProgress color="inherit" size={20} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
          )}
          <Grid size={{ xs: 12, sm: 4, md: 3 }} sx={{ minWidth: 400 }}>
            <TextField
              label="Từ khoá"
              fullWidth
              size="small"
              value={searchKeyword}
              onChange={(e) => setSearchKeyword(e.target.value)}
            />
          </Grid>
          <Grid>
            <Button
              variant="contained"
              startIcon={<SearchIcon />}
              onClick={onSearch}
              sx={{ height: "40px" }}
            >
              Tìm kiếm
            </Button>
          </Grid>
        </Grid>
      </Paper>
    );
  },
);

export default InvoiceTemplateFilter;
